module.exports = __webpack_public_path__ + "img/cloche.657e1284.svg";